<section class="content">
    <div class="title-container">
        <h1 class="title" >Adicional de remuneração</h1>
        <h2 class="subtitle">Percentual para atuação em contextos específicos.</h2>
    </div>

    <hr class="division-line" />

    <div class="panel dropdown-panel">
        <app-menu-suspenso #menuTooltip="matTooltip" [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
            matTooltipPosition="above" (chamadaDeAcao)="chamarAcao($event)" [opcoes]="[
        {
          rotulo: 'PQR desta funcionalidade',
          icone: 'computer',
          acao: 'pqrDestaFuncionalidade'
        },
        {
          rotulo: 'Restaurar valores com base no PQR',
          icone: 'content_copy',
          acao: 'restaurarValoresComBaseNoPqr'
        },
        {
          rotulo: 'PQR completo em nova aba',
          icone: 'desktop_windows',
          acao: 'pqrCompletoEmNovaAba'
        }
      ]">
            Padrão de qualidade de referência (PQR)
        </app-menu-suspenso>

        <mat-icon class="info-icon" #infoTooltip="matTooltip" matTooltip="Informações sobre o PQR"
            matTooltipPosition="left" (mouseenter)="openTooltips()" (mouseleave)="closeTooltips()">
            info
        </mat-icon>
    </div>

    <div class="panel">
        <app-tabela ngSkipHydration class="table-component" [cabecalhoCustomizado]="true">
            <ng-container cabecalho>
                <tr>
                    <th class="table-header" style="width: 30%">Item</th>
                    <th class="table-header" style="width: 16%">Percentual (%)</th>
                </tr>
            </ng-container>
            <ng-container corpo>
                <tr *ngFor="let dados of dadosTabela">
                    <td class="table-cell align-left">
                      {{ obterDescricaoItem(dados) }}
                    </td>
                    <td class="table-cell">
                        <input class="display-input text-green"
                               [maskito]="mask_porcentagem_limpa"
                               [(ngModel)]="dados.percentual"
                               (ngModelChange)="atualizarDadosDoServicoDeEstado(dados,$event)"
                               />
                    </td>
                </tr>
            </ng-container>
        </app-tabela>
    </div>
</section>
